import { AxiosPromise } from 'axios'
import { BootstrapPingRequest, BootstrapPingResponse,WidgetBootstrapParams, WidgetBootstrapResponse } from 'types/bootstrap'

import { BootstrapFormApi, BootstrapJsonApi } from '.'
import { getDefaultAuthParams } from './auth'

export const executeWidgetBootstrapForMode = (mode: string, orgId: number, params: WidgetBootstrapParams) => {
  switch(mode) {
    case 'LANDING_PAGE':
      return landingPageBootstrap(orgId, params)
    case 'CHAT':
    default:
      return widgetBootstrap(orgId, params)
  }
}

export const executeBootstrapPing = (payload: BootstrapPingRequest): AxiosPromise<BootstrapPingResponse> => {
  return BootstrapJsonApi.post('widget_bootstrap/ping', payload)
}

const widgetBootstrap = (orgId: number, params: WidgetBootstrapParams) => {
  const defaultAuthParams = getDefaultAuthParams(orgId)

  return BootstrapFormApi.post<WidgetBootstrapResponse>('widget_bootstrap', {
    data: { ...defaultAuthParams, ...params }
  })
}

const landingPageBootstrap = (orgId: number, params: WidgetBootstrapParams) => {
  const defaultAuthParams = getDefaultAuthParams(orgId)

  return BootstrapFormApi.post<WidgetBootstrapResponse>('widget_bootstrap/landing_page', {
    data: { ...defaultAuthParams, ...params }
  })
}
